<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="6 11 20 18" fill="none">
    <path
      d="M14 14V26M18 14V26M13.2 14H18.8C19.9201 14 20.4802 14 20.908 14.218C21.2843 14.4097 21.5903 14.7157 21.782 15.092C22 15.5198 22 16.0799 22 17.2V22.8C22 23.9201 22 24.4802 21.782 24.908C21.5903 25.2843 21.2843 25.5903 20.908 25.782C20.4802 26 19.9201 26 18.8 26H13.2C12.0799 26 11.5198 26 11.092 25.782C10.7157 25.5903 10.4097 25.2843 10.218 24.908C10 24.4802 10 23.9201 10 22.8V17.2C10 16.0799 10 15.5198 10.218 15.092C10.4097 14.7157 10.7157 14.4097 11.092 14.218C11.5198 14 12.0799 14 13.2 14Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
